import React, { useState } from "react";
import { Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig.js";
import CustomTooltip from "utils/CustomTooltip";
import { Row, Col } from "react-bootstrap";

export default function AccountIdBox(props) {
	const [platformEnabled, setPlatformEnabled] = useState(
		jsDig(["enabled"], props.platformData)
			? jsDig(["enabled"], props.platformData)
			: false
	);

	const accountids = jsDig(["account_ids"], props.platformData)?jsDig(["account_ids"], props.platformData) : [""]

	const tooltipMessage = <div>Note: Microsoft Ads account IDs must now be taken from the URL. Select the account from the initial list of accounts, then check the url for the "aid" parameter. The account id directly follows the = symbol. {props.example}</div>
	
	return (
		<>
			<Row>
					
				<CustomFormCheck
					id={props.platformId}
					label={`Enable ${props.platformName}`}
					checked={platformEnabled}
					name={`${props.fieldName}[enabled]`}
					sendUncheckedValue
					onChange={() => {
						setPlatformEnabled(!platformEnabled);
					}}
					/>		
					{props.example &&
                	<CustomTooltip  
					className="d-inline"
					faClass="far fa-question-circle pl-2"
					message= {tooltipMessage}
					style={{display: "inline"}}
					inline={true}
					/> 
					}
						
				 
				
		</Row>
			<div
				style={{ backgroundColor: "#f5f5f5"}}
				className="table-responsive mt-3 px-3 ml-0 ml-md-3 py-1"
			>
				<div className="d-flex align-items-center row p-4">
					<p className="d-inline f14 nunito-regular mr-3 primary">ID number</p>
					{
						accountids.length > 0 ? (accountids.map((accountId,index)=>{
							return(
								<Form.Control
									key={index}
									className="d-inline"
									readOnly={!platformEnabled}
									size="sm"
									style={{ width: "200px" }}
									name={`${props.fieldName}[account_ids][]`}
									defaultValue={accountId.id}
									/>
							)
						}))
						: (
							<Form.Control
									className="d-inline"
									readOnly={!platformEnabled}
									size="sm"
									style={{ width: "200px" }}
									name={`${props.fieldName}[account_ids][]`}
									defaultValue={""}
									
								/>
						)
					}
					
				</div>
			</div>
		</>
	);
}
